// extracted by mini-css-extract-plugin
export var container = "styles-module--container--onrD+";
export var buttonHome = "styles-module--buttonHome--fnEo7";
export var buttonTransparent = "styles-module--buttonTransparent--sqUlA";
export var rightButtonsWrapper = "styles-module--rightButtonsWrapper--Z0PNi";
export var buttonSignUp = "styles-module--buttonSignUp--VqRFD";